// extracted by mini-css-extract-plugin
export default {"wrapper":"AssetLayer_wrapper__wFpS5","rounded":"AssetLayer_rounded__RzT+E","roundedTop":"AssetLayer_roundedTop__QopG9"};